import React, { PureComponent } from 'react'
import { Popover, Overlay, Button, Glyphicon } from 'react-bootstrap'
import { dossierSubTypeId as dossierSubTypes } from '../../constants/dossier/common/dossierSubType.js'
import PopoverItem from '../../containers/search/PopoverItemPage.js'
class VehiclePopover extends PureComponent {
  constructor () {
    super()
    this.state = {
      showPopover: false,
      target: this
    }
  }

  handleClick (e) {
    e.stopPropagation()
    this.setState({ target: e.target, showPopover: true })
  }

  getHeaderText (isHeader) {
    const vehicle = this.props.vehicle
    const dossierSubTypeId = this.props.dossierSubTypeId
    let headerTextReturn = vehicle.vehicleVinChassis || vehicle.vehicleModel || vehicle.vehicleBrand || vehicle.vehicleLicensePlate
    const licensePlateFirst = vehicle.vehicleLicensePlate || vehicle.vehicleVinChassis || vehicle.vehicleModel || vehicle.vehicleBrand

    if (dossierSubTypeId === dossierSubTypes.venta_vo || dossierSubTypeId === dossierSubTypes.compra_vo || dossierSubTypeId === dossierSubTypes.tramite ||
      dossierSubTypeId === dossierSubTypes.stock_vo) {
      headerTextReturn = licensePlateFirst
    } else {
      if (!dossierSubTypeId) {
        if (isHeader && vehicle.vehicleLicensePlate && vehicle.vehicleVinChassis) {
          return vehicle.vehicleLicensePlate + ' (' + vehicle.vehicleVinChassis + ')'
        } else {
          headerTextReturn = licensePlateFirst
        }
      }
    }

    return isHeader && headerTextReturn.length > 20 ? headerTextReturn.substring(0, 15) + '...' : headerTextReturn
  }

  render () {
    const {
      idx,
      id,
      isHeader,
      vehicle = {}
    } = this.props
    const renderComponent = vehicle.vehicleVinChassis || vehicle.vehicleModel || vehicle.vehicleBrand || vehicle.vehicleLicensePlate
    return (
      <div>
        {renderComponent &&
          <Button bsSize="xsmall" className="icon-only" onClick={this.handleClick.bind(this)} id={'vehicle_popOver_button_' + idx}><Glyphicon glyph="plus"/></Button>
        }
        <div className="text-popover">
          { renderComponent && this.getHeaderText(isHeader) }
        </div>
        <Overlay
          container={this}
          show={this.state.showPopover}
          target={this.state.target}
          onHide={() => this.setState({ showPopover: false })}
          rootClose
          placement={'bottom'}
        >
          <Popover id={id} className="_nf-popover">
            {vehicle.vehicleLicensePlate &&
              <PopoverItem itemType={'veh_07'} data={vehicle.vehicleLicensePlate}></PopoverItem>
            }
            {vehicle.vehicleVinChassis &&
              <PopoverItem itemType={'veh_01'} data={vehicle.vehicleVinChassis}></PopoverItem>
            }
            {vehicle.vehicleBrand &&
              <PopoverItem itemType={'veh_06'} data={vehicle.vehicleBrand}></PopoverItem>
            }
            {vehicle.carline &&
              <PopoverItem itemType={'veh_02'} data={vehicle.carline}></PopoverItem>
            }
            {vehicle.catalogue &&
              <PopoverItem itemType={'veh_03'} data={vehicle.catalogue}></PopoverItem>
            }
            {vehicle.modelYear &&
              <PopoverItem itemType={'veh_04'} data={vehicle.modelYear}></PopoverItem>
            }
            {vehicle.vehicleModel &&
              <PopoverItem itemType={'veh_05'} data={vehicle.vehicleModel}></PopoverItem>
            }
            {vehicle.comercialCode &&
              <PopoverItem itemType={'veh_08'} data={vehicle.comercialCode}></PopoverItem>
            }
            {vehicle.licensePlateDate &&
              <PopoverItem itemType={'veh_09'} data={vehicle.licensePlateDate}></PopoverItem>
            }
            {vehicle.color &&
              <PopoverItem itemType={'veh_10'} data={vehicle.color}></PopoverItem>
            }
            {vehicle.tapestry &&
              <PopoverItem itemType={'veh_11'} data={vehicle.tapestry}></PopoverItem>
            }
          </Popover>
        </Overlay>
      </div>
    )
  }
}

export default VehiclePopover
